"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _Input = _interopRequireDefault(require("../Input"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

var _vars = _interopRequireDefault(require("../../constants/vars"));

var _Search = _interopRequireDefault(require("../Icons/Search"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tborder: ", " solid ", ";\n\tpadding: ", ";\n\tborder-radius: ", ";\n\tsvg {\n\t\tdisplay: inline-block;\n\t\tvertical-align: middle;\n\t}\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: 0 !important;\n\toutline: 0;\n\tpadding: 0 !important;\n\tvertical-align: middle;\n\tpadding-left: ", " !important;\n\t&:hover,\n\t&:focus {\n\t\tbox-shadow: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var InputField = (0, _styledComponents.default)(_Input.default)(_templateObject(), _spacing.default.s2);

var Container = _styledComponents.default.div(_templateObject2(), _vars.default.borderWidth, _colors.default.borderColor, _spacing.default.s1, _vars.default.borderRadius);

Container.displayName = 'Container';
InputField.displayName = 'Input';

var InputWithIcon = function InputWithIcon(_ref) {
  var Icon = _ref.Icon,
      size = _ref.size,
      rest = _objectWithoutPropertiesLoose(_ref, ["Icon", "size"]);

  return _react.default.createElement(Container, rest, _react.default.createElement(Icon, {
    size: size,
    color: _colors.default.borderColor,
    style: {
      verticalAlign: 'middle'
    }
  }), _react.default.createElement(InputField, null));
};

InputWithIcon.displayName = 'InputWithIcon';
InputWithIcon.propTypes = {
  Icon: _propTypes.func,
  size: _propTypes.number
};
InputWithIcon.defaultProps = {
  Icon: _Search.default,
  size: 16
};
var _default = InputWithIcon;
exports.default = _default;